import { render, staticRenderFns } from "./VideoTable.vue?vue&type=template&id=d1b9b16c&"
import script from "./VideoTable.vue?vue&type=script&lang=js&"
export * from "./VideoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/devteam/projects/dominion-conference-app/ConferenceAdmin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports